import React, { useEffect, useState } from "react";
import Accordion from "../../component/global/accordion";
import Drawer from "../../component/global/drawer";
import ViewConfig from "../../config/viewConfig";
import { addData, baseUrl, loadData } from "../../config/data";
import { loadCurrentApplicantCompletion, loadCurrentApplicantProfile } from "../../config/applicantApi";
import AutoResizeTextArea from "../../component/layout/text_area";
import axios from "axios";
import Swal from "sweetalert2";
import '../../index.css'
import JobDrawer from "../../component/global/jobDrawer";
import { useDispatch, useSelector } from "react-redux";
import Lang from "../../config/lang";
import ModalContent from "../../component/global/modal";
import { getQueryParam } from "../../config/helper";
import { useLocation, useParams, useSearchParams } from "react-router-dom";
import { setLanguage } from "../../redux/actions/language";
import { useDrawerTransition } from "../../context/drawerProvider";

const Portal = ({ }) => {
    const location = useLocation();
    const { jobID } = location.state || {};
    const userToken = localStorage?.getItem('authToken') || '';
    const { startTransition } = useDrawerTransition();
    const [searchParams] = useSearchParams();
    const { lang } = useSelector((state) => state.globalReducer);
    const [keywords, setkeywords] = useState(getQueryParam("search") || '');
    const [idParam, setIDParam] = useState(getQueryParam("id") || '');
    const [inputValue, setInputValue] = useState('');
    const [filter, setFilter] = useState('');
    const [isDrawerOpen, setIsDrawerOpen] = useState(false);
    const [drawerTitle, setDrawerTitle] = useState('Menu');
    const [jobListData, setJobListData] = useState([]);
    const [jobListTotal, setJobListTotal] = useState(0);
    const [selectedLocation, setSelectedLocation] = useState('');
    const [locationOptions, setlocationOptions] = useState([]);
    const [jobTypeOptions, setJobTypeOptions] = useState([]);
    const [departmentOptions, setDepartmentOptions] = useState([]);
    const [selectedDepartment, setSelectedDepartment] = useState('');
    const [selectedJobType, setSelectedJobType] = useState('');
    const [selectedOrderBy, setSelectedOrderBy] = useState('newest');
    const [selectedDropdown, setSelectedDropdown] = useState('');
    const [jobData, setJob] = useState([]);
    const [jobPage, setjobPage] = useState(0);
    const [isLoading, setisLoading] = useState(false);
    const [jobListLoading, setJobListLoading] = useState(false);
    const [jobListError, setJobListError] = useState(false);
    const [filterLoading, setFilterLoading] = useState({
        location: false,
        department: false,
        jobType: false,
    });
    const [filterError, setFilterError] = useState({
        location: false,
        department: false,
        jobType: false,
    });
    const [isMobileSearchExpanded, setIsMobileSearchExpanded] = useState(Boolean(getQueryParam("search")));
    const [isMobileFiltersExpanded, setIsMobileFiltersExpanded] = useState(false);

    const mobileView = ViewConfig();
    const localStatus = localStorage?.getItem('showModal');
    const [isModalOpen, setModalOpen] = useState(localStatus === 'false' ? false : true);
    const openModal = () => setModalOpen(true);
    const closeModal = () => setModalOpen(false);
    const hasRun = React.useRef(false);


    const dispatch = useDispatch();

    const orderByOptions = ['newest', 'oldest'];
    const { language } = useParams();

    useEffect(() => {
        localStorage?.setItem('showModal', false);
    }, [isModalOpen])

    useEffect(() => {
        if (language) {
            dispatch(setLanguage(language));
        }
    }, [language])

    const renderModal = () => {
        return (
            <ModalContent isOpen={isModalOpen} onClose={() => {
                closeModal();
            }} position={"center"} title={``} setWidth={mobileView ? "80%" : "60%"} setHeight="auto">
                <div className="flex items-start">
                    <div className="hidden md:block">
                        <img className="w-[300px] rounded-ss-[20px]" src={"/asset/warning_large.png"} />
                    </div>
                    <div className="flex flex-col gap-4 items-center w-full">
                        {/* <p className="text-[#EA2427] font-semibold text-center text-xl md:text-3xl mt-1 md:mt-[4rem] mb-3 md:mb-1">Waspada Penipuan <br /> Rekrutmen Karyawan</p> */}
                        <p className="text-[#EA2427] font-semibold text-center text-xl md:text-3xl mt-1 md:mt-[4rem] mb-3 md:mb-1 w-[360px]">{Lang(lang, 'modal_header')}</p>
                        <p className="text-center w-[80%] mx-auto text-xs md:text-sm"><b>Sopra Group</b> {Lang(lang, 'modal_desc')}
                            <br /><br />
                            {Lang(lang, 'modal_desc_2')}
                        </p>
                        <br />
                    </div>
                    <div className="hidden md:flex flex-row items-center gap-1 cursor-pointer p-6" onClick={() => closeModal()}>
                        <img src={"/asset/icon/close.svg"} />
                    </div>
                </div>
            </ModalContent>
        )
    }

    useEffect(() => {
        if (keywords) {
            setInputValue(keywords);
            loadJobata(keywords, '', 0);
        } else {
            if (jobID) {
                if (hasRun.current) return;
                hasRun.current = true;
                loadJobata('', jobID, null, true)
            } else if (idParam) {
                const decodedParam = atob(idParam)
                loadJobata('', decodedParam, 0)
            } else {
                setInputValue('');
                loadJobata('', '', 0);
            }
        }

    }, [keywords, selectedJobType, selectedLocation, selectedDepartment, selectedOrderBy, idParam])

    useEffect(() => {
        if (filter===false) {
            setInputValue('');
            loadJobata('', '', 0);
        }
    }, [filter])


    const submitApplication = async (job) => {
        try {
            if (!userToken) {
                showError(Lang(lang, 'session_expired'))
                setTimeout(() => {
                    startTransition(`/${lang}/login?from=portal`, { jobID: job?.jobID });
                }, 3000);
                return;
            }

            const result = await loadCurrentApplicantCompletion({
                userToken,
            });

            if (result !== 10) {
                showError(Lang(lang, 'profile_not_complete'))
                setTimeout(() => {
                    startTransition(`/${lang}/profile`, { jobID: job?.jobID });
                }, 3000);
                return;
            }

            const profileData = await loadCurrentApplicantProfile({ userToken });

            if (
                !profileData
                || !profileData.gender
                || !profileData.fullName
                || !profileData.email
                || !profileData.mobilePhoneNumber
            ) {
                showError(Lang(lang, 'profile_not_complete'))
                setTimeout(() => {
                    startTransition(`/${lang}/profile`, { jobID: job?.jobID });
                }, 3000);
                return;
            }

            setisLoading(true)
            const candidateData = {
                candidateName: profileData.fullName,
                email: profileData.email,
                phoneNumber: profileData.mobilePhoneNumber,
                resumeURL: profileData.resumeURL || '',
                remarks: '',
                jobID: job.jobID,
                status: 'Screening'
            };

            await addData({
                url: 'Candidates',
                params: candidateData,
                userToken,
            }).then(async res => {
                if (res?.data) {
                    setTimeout(() => {
                        setisLoading(false)
                        showSuccess(Lang(lang, 'apply_job_success'))
                    }, 500);
                } else {
                    setTimeout(() => {
                        setisLoading(false)
                        showError(res)
                    }, 500);
                }
            })
        } catch (error) {
            setTimeout(() => {
                setisLoading(false)
                showError(error)
            }, 500);
        }
    }

    const showError = (error) => {
        Swal.fire({
            title: `${Lang(lang, 'warning')}!`,
            text: error || Lang(lang, 'apply_job_failed'),
            icon: 'warning',
            timer: 3000,
            showConfirmButton: false,
            customClass: {
                popup: 'my-custom-popup'
            }
        });
    };

    const showSuccess = (message) => {
        Swal.fire({
            title: 'Success!',
            text: message || 'Action Successful!',
            icon: 'success',
            timer: 3000,
            showConfirmButton: false,
            customClass: {
                popup: 'my-custom-popup'
            }
        });
    };


    useEffect(() => {
        loadJoFiltersLocation();
        loadJoFiltersJobType();
        loadJoFiltersDepartment();
    }, [])

    const loadJobata = async (keywords, id, page, isAutoApply) => {
        const now = new Date();
        const formattedDate = now.toISOString().split("T")[0].slice(0, 10);
        setjobPage(page === 0 ? 0 : (jobPage + 1))
        setJobListLoading(true);
        setJobListError(false);
        const timeout = setTimeout(() => {
            setJobListLoading(false);
            setJobListError(true);
        }, 15000);
        await loadData({
            url: id ? `Jobs/${id}` : `Jobs`,
            params: [{ title: 'limit', value: 10 }, { title: 'page', value: page === 0 ? 0 : (jobPage + 1) }, { title: 'search', value: keywords || '' }, { title: 'date', value: formattedDate }, { title: 'filter', value: `type:${selectedJobType}|location:${selectedLocation}|department:${selectedDepartment}` }],
            throwOnError: true,
        }).then(async res => {
            if (res?.data) {
                clearTimeout(timeout);
                setJobListError(false);
                let resData;
                if (id) {
                    if (res?.data) {
                        resData = [res?.data];
                        setFilter(resData[0].jobTitle)
                    }
                } else {
                    resData = res?.data;
                }
                const simplifiedJobs = resData.map(job => ({
                    job: job,
                    jobID: job.jobID,
                    title: job.jobTitle,
                    tags: [job?.location, job?.jobType, job?.department],
                    companyID: job.companyID,
                    publicationDate: job.publicationDate,
                    jobDescription: job.jobDescription,
                    jobDescription_Id: job.jobDescription_Id,
                    location: job?.location,
                }));

                if (jobID && isAutoApply) submitApplication(simplifiedJobs[0]);

                if (selectedOrderBy === 'newest') {
                    const sortedJobs = [...simplifiedJobs].sort(
                        (a, b) => new Date(b.publicationDate) - new Date(a.publicationDate)
                    );
                    if (id || page === 0) {
                        setJobListData(sortedJobs);
                    } else {
                        setJobListData(prev => [...prev, ...sortedJobs]);
                    }
                } else {
                    const sortedJobs = [...simplifiedJobs].sort(
                        (a, b) => new Date(a.publicationDate) - new Date(b.publicationDate)
                    );
                    if (!(page === 0)) {
                        setJobListData(prev => [...prev, ...sortedJobs]);
                    } else {
                        setJobListData(sortedJobs);
                    }
                }
                setJobListTotal(res?.total)
            }
        }).catch(() => {
            setJobListError(true);
        }).finally(() => {
            clearTimeout(timeout);
            setJobListLoading(false);
        })
    };


    const loadJoFiltersDepartment = async () => {
        setFilterLoading(prev => ({ ...prev, department: true }));
        setFilterError(prev => ({ ...prev, department: false }));
        const timeout = setTimeout(() => {
            setFilterLoading(prev => ({ ...prev, department: false }));
            setFilterError(prev => ({ ...prev, department: true }));
        }, 10000);
        loadData({
            url: `Jobs/filters`,
            params: [{ title: 'filter', value: 'type:department' }],
            throwOnError: true,
        }).then(async res => {
            if (res?.department) {
                setFilterError(prev => ({ ...prev, department: false }));
                const resData = res?.department;
                setDepartmentOptions(resData)
            }
        }).catch(() => {
            setFilterError(prev => ({ ...prev, department: true }));
        }).finally(() => {
            clearTimeout(timeout);
            setFilterLoading(prev => ({ ...prev, department: false }));
        })
    };

    const loadJoFiltersLocation = async () => {
        setFilterLoading(prev => ({ ...prev, location: true }));
        setFilterError(prev => ({ ...prev, location: false }));
        const timeout = setTimeout(() => {
            setFilterLoading(prev => ({ ...prev, location: false }));
            setFilterError(prev => ({ ...prev, location: true }));
        }, 10000);
        loadData({
            url: `Jobs/filters`,
            params: [{ title: 'filter', value: 'type:location' }],
            throwOnError: true,
        }).then(async res => {
            if (res?.location) {
                setFilterError(prev => ({ ...prev, location: false }));
                const resData = res?.location;
                setlocationOptions(resData)
            }
        }).catch(() => {
            setFilterError(prev => ({ ...prev, location: true }));
        }).finally(() => {
            clearTimeout(timeout);
            setFilterLoading(prev => ({ ...prev, location: false }));
        })
    };


    const loadJoFiltersJobType = async () => {
        setFilterLoading(prev => ({ ...prev, jobType: true }));
        setFilterError(prev => ({ ...prev, jobType: false }));
        const timeout = setTimeout(() => {
            setFilterLoading(prev => ({ ...prev, jobType: false }));
            setFilterError(prev => ({ ...prev, jobType: true }));
        }, 10000);
        loadData({
            url: `Jobs/filters`,
            params: [{ title: 'filter', value: 'type:jobType' }],
            throwOnError: true,
        }).then(async res => {
            if (res?.jobtype) {
                setFilterError(prev => ({ ...prev, jobType: false }));
                const resData = res?.jobtype;
                setJobTypeOptions(resData)
            }
        }).catch(() => {
            setFilterError(prev => ({ ...prev, jobType: true }));
        }).finally(() => {
            clearTimeout(timeout);
            setFilterLoading(prev => ({ ...prev, jobType: false }));
        })
    };

    const retryFailedFilters = () => {
        if (filterError.location || locationOptions.length === 0) loadJoFiltersLocation();
        if (filterError.department || departmentOptions.length === 0) loadJoFiltersDepartment();
        if (filterError.jobType || jobTypeOptions.length === 0) loadJoFiltersJobType();
    };

    const retryJobsAndFailedFilters = () => {
        retryFailedFilters();
        loadJobata(keywords, idParam ? atob(idParam) : '', 0);
    };

    const arrFilter = [
        { label: Lang(lang, 'location') },
        { label: Lang(lang, 'department') },
        { label: Lang(lang, 'jobType') },
        { label: Lang(lang, 'orderBy') },
    ]

    const activeIsLocationDropdown = selectedDropdown === Lang(lang, 'location');
    const activeIsDepartmentDropdown = selectedDropdown === Lang(lang, 'department');
    const activeIsJobTypeDropdown = selectedDropdown === Lang(lang, 'jobType');
    const activeDropdownOptions = activeIsLocationDropdown
        ? locationOptions
        : activeIsDepartmentDropdown
            ? departmentOptions
            : activeIsJobTypeDropdown
                ? jobTypeOptions
                : selectedDropdown === Lang(lang, 'orderBy')
                    ? orderByOptions
                    : [];
    const activeDropdownLoading = activeIsLocationDropdown
        ? filterLoading.location
        : activeIsDepartmentDropdown
            ? filterLoading.department
            : activeIsJobTypeDropdown
                ? filterLoading.jobType
                : false;
    const activeDropdownError = activeIsLocationDropdown
        ? filterError.location
        : activeIsDepartmentDropdown
            ? filterError.department
            : activeIsJobTypeDropdown
                ? filterError.jobType
                : false;

    const filterComponent = (title, closeFunction) => (
        <div className="flex flex-row items-center gap-3 justify-center w-fit bg-[#E4F0FF] border border-[#193CB8] py-1.5 px-4 md:py-2 md:px-5 rounded-full shadow-sm transition-all hover:bg-[#d4e6ff]">
            <p className="text-[#193CB8] text-[13px] md:text-[15px] font-medium">{title}</p>
            <a href="" onClick={(e) => {
                e.preventDefault();
                closeFunction()
            }} className="w-2.5 h-2.5 md:w-3 md:h-3 opacity-70 hover:opacity-100 transition-opacity"><img src={"/asset/icon/close.svg"} className="w-full h-full object-contain" /></a>
        </div>
    )

    return (<div className="pb-20">
        <div className="pt-8">
            <p className='text-[#48494B] text-[32px] md:text-[84px] w-[80%] md:w-full mx-auto font-normal leading-tight text-center'>{Lang(lang, 'build_your')} <b className='text-[#034694] font-semibold'>{Lang(lang, 'career')}</b> {(lang === 'id' ? 'Anda ' : '') + Lang(lang, 'at')} <b className='text-[#EA2427] font-semibold'>SOPRA</b></p>
            <div className="w-[85%] md:w-[70%] mx-auto pt-12 flex flex-row justify-center items-center gap-3 md:gap-4">
                <div className={`${isMobileSearchExpanded ? 'flex-1 flex items-center' : 'hidden md:block md:flex-1'}`}>
                    <div className='relative w-full'>
                        <div className="absolute inset-y-0 start-0 flex items-center ps-5 md:ps-6 pointer-events-none">
                            <svg className="w-4 h-4 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                            </svg>
                        </div>

                        <input
                            type="search"
                            id="default-search"
                            className="block w-full p-3 md:p-4 ps-11 md:ps-14 pe-12 md:pe-16 text-sm md:text-base text-gray-900 border border-gray-300 rounded-[35px] bg-[#FFFFFF] transition-shadow focus:ring-2 focus:ring-[#034694]/20"
                            placeholder={Lang(lang, 'search_job_hint')}
                            value={inputValue}
                            required
                            style={{ boxShadow: '0px 4px 15px rgba(0, 118, 255, 0.08)' }}
                            onChange={(e) => {
                                if (e.target.value === '') {
                                    loadJobata('', '', 0);
                                    window.history.replaceState({}, "", `?search=`);
                                }
                                setInputValue(e.target.value);
                            }}
                            onKeyUp={(e) => {
                                if (e.key === "Enter") {
                                    if (inputValue) {
                                        setkeywords(inputValue);
                                        window.history.replaceState({}, "", `/${lang}/portal?search=${inputValue}`);
                                    } else {
                                        setkeywords('');
                                        window.history.replaceState({}, "", `?search=`);
                                    }
                                }
                            }}
                        />
                        <div className='absolute end-2 bottom-[8px] md:bottom-1.5 cursor-pointer hover:scale-105 transition-transform' onClick={() => {
                            if (inputValue) {
                                setkeywords(inputValue);
                                window.history.replaceState({}, "", `/${lang}/portal?search=${inputValue}`);
                            } else {
                                setkeywords('');
                                window.history.replaceState({}, "", `?search=`);
                            }
                        }} >
                            <img src="/asset/submitBtn.png" className="w-[30px] h-[30px] md:w-[45px] md:h-[45px]" />
                        </div>
                    </div>
                </div>

                {!isMobileSearchExpanded && (
                    <div 
                        className="md:hidden flex items-center justify-center w-[45px] h-[45px] bg-white rounded-full border border-gray-300 cursor-pointer shrink-0 transition-transform active:scale-95"
                        style={{ boxShadow: '0px 4px 15px rgba(0, 118, 255, 0.08)' }}
                        onClick={() => setIsMobileSearchExpanded(true)}
                    >
                        <svg className="w-5 h-5 text-gray-500" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 20 20">
                            <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="m19 19-4-4m0-7A7 7 0 1 1 1 8a7 7 0 0 1 14 0Z" />
                        </svg>
                    </div>
                )}

                <div 
                    className={`md:hidden flex items-center justify-center w-[45px] h-[45px] rounded-full border cursor-pointer shrink-0 transition-all active:scale-95 ${isMobileFiltersExpanded ? 'bg-[#034694] border-[#034694]' : 'bg-white border-gray-300'}`}
                    style={{ boxShadow: '0px 4px 15px rgba(0, 118, 255, 0.08)' }}
                    onClick={() => setIsMobileFiltersExpanded(!isMobileFiltersExpanded)}
                >
                    <svg className={`w-5 h-5 ${isMobileFiltersExpanded ? 'text-white' : 'text-gray-500'}`} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <path stroke="currentColor" strokeLinecap="round" strokeWidth="2" d="M4 6h16M7 12h10M10 18h4"/>
                    </svg>
                </div>
            </div>
            
            <div 
                className={`relative flex flex-wrap justify-center md:items-center gap-2 md:gap-4 w-[85%] md:w-[70%] mx-auto transition-all duration-300 ease-in-out origin-top ${
                    isMobileFiltersExpanded 
                        ? 'max-h-[500px] opacity-100 pt-4 md:pt-6 overflow-visible' 
                        : 'max-h-0 opacity-0 pt-0 overflow-hidden md:max-h-[500px] md:opacity-100 md:pt-6 md:overflow-visible'
                }`}
            >
                {arrFilter?.map((val, idx) => {
                    return (
                    <div key={idx} className="flex flex-col" style={{ position: 'relative' }} >
                        <a href="" onClick={(e) => {
                            e.preventDefault();
                            if (!filter) {
                                if (selectedDropdown === val.label) {
                                    setSelectedDropdown('')
                                } else {
                                    setSelectedDropdown(val.label);
                                }
                            }
                        }} className={`rounded-full border border-[#a1a4a8] flex justify-between items-center py-1.5 px-3 md:py-2 md:px-6 gap-1.5 md:gap-2 w-auto min-w-fit transition-colors hover:bg-gray-50${filter && ' bg-gray-200 text-gray-400'}`} key={idx}
                            style={selectedDropdown === val.label ? { backgroundColor: '#034694', borderColor: '#034694' } : {}}>
                            <p className={`text-[11px] md:text-[15px] font-medium whitespace-nowrap${filter && ' text-gray-400'}`} style={selectedDropdown === val.label ? { color: 'white' } : {}}>{val.label}</p>
                            <svg data-accordion-icon className={selectedDropdown !== val.label ? "w-3 h-3 rotate-180 shrink-0" : "w-3 h-3 shrink-0"} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 10 6" style={selectedDropdown === val.label ? { color: 'white' } : {}}>
                                <path stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M9 5 5 1 1 5" />
                            </svg>
                        </a>
                        {selectedDropdown === val.label && <div
                            style={{
                                maxHeight: '260px',
                                overflowY: 'auto',
                                overscrollBehavior: 'contain',
                                zIndex: 999,
                            }}
                            className="glass-card-dropdown absolute right-0 top-full mt-2 hidden rounded-[12px] p-[10px] md:block md:min-w-[200px]"
                        >
                            {activeDropdownLoading && (
                                <div style={{ padding: '8px', color: '#000' }}>
                                    {Lang(lang, 'loading')}
                                </div>
                            )}
                            {!activeDropdownLoading && activeDropdownError && (
                                <div style={{ padding: '8px', color: '#000' }}>
                                    <p>{Lang(lang, 'failed_to_load_data')}</p>
                                    <button
                                        type="button"
                                        className="text-[#034694] font-semibold mt-1"
                                        onClick={retryFailedFilters}
                                    >
                                        {Lang(lang, 'retry')}
                                    </button>
                                </div>
                            )}
                            {!activeDropdownLoading && !activeDropdownError && activeDropdownOptions.length === 0 && (
                                <div style={{ padding: '8px', color: '#000' }}>
                                    {Lang(lang, 'no_data')}
                                </div>
                            )}
                            {!activeDropdownLoading && !activeDropdownError && activeDropdownOptions.map((option) => (
                                <label
                                    key={option}
                                    style={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        padding: '8px',
                                        cursor: 'pointer',
                                        color: '#000',
                                        fontSize: '14px',
                                        whiteSpace: 'nowrap'
                                    }}
                                >
                                    <input
                                        type="checkbox"
                                        checked={selectedOrderBy === option || selectedDepartment === option || selectedJobType === option || selectedLocation === option}
                                        onChange={() => {
                                            switch (selectedDropdown) {
                                                case Lang(lang, 'location'):
                                                    if (selectedLocation === option) {
                                                        setSelectedLocation('')
                                                    } else {
                                                        setSelectedLocation(option)
                                                    }
                                                    setSelectedDropdown('')
                                                    break;
                                                case Lang(lang, 'department'):
                                                    if (selectedDepartment === option) {
                                                        setSelectedDepartment('')
                                                    } else {
                                                        setSelectedDepartment(option)
                                                    }
                                                    setSelectedDropdown('')
                                                    break;
                                                case Lang(lang, 'jobType'):
                                                    if (selectedJobType === option) {
                                                        setSelectedJobType('')
                                                    } else {
                                                        setSelectedJobType(option)
                                                    }
                                                    setSelectedDropdown('')
                                                    break;
                                                case Lang(lang, 'orderBy'):
                                                    if (selectedOrderBy === option) {
                                                        setSelectedOrderBy('')
                                                    } else {
                                                        setSelectedOrderBy(option)
                                                    }
                                                    setSelectedDropdown('')
                                                    break;
                                                default:
                                                    break;
                                            }
                                        }}
                                        style={{ marginRight: '8px' }}
                                    />
                                    {selectedDropdown === Lang(lang, 'orderBy') ? Lang(lang, option) : option}
                                </label>
                            ))}
                        </div>}
                    </div>
                    );
                })}
                {selectedDropdown && <div
                    style={{
                        maxHeight: '260px',
                        overflowY: 'auto',
                        overscrollBehavior: 'contain',
                        zIndex: 999,
                    }}
                    className="glass-card-dropdown mt-2 w-full rounded-[12px] p-[10px] md:hidden"
                >
                    {activeDropdownLoading && (
                        <div style={{ padding: '8px', color: '#000' }}>
                            {Lang(lang, 'loading')}
                        </div>
                    )}
                    {!activeDropdownLoading && activeDropdownError && (
                        <div style={{ padding: '8px', color: '#000' }}>
                            <p>{Lang(lang, 'failed_to_load_data')}</p>
                            <button
                                type="button"
                                className="text-[#034694] font-semibold mt-1"
                                onClick={retryFailedFilters}
                            >
                                {Lang(lang, 'retry')}
                            </button>
                        </div>
                    )}
                    {!activeDropdownLoading && !activeDropdownError && activeDropdownOptions.length === 0 && (
                        <div style={{ padding: '8px', color: '#000' }}>
                            {Lang(lang, 'no_data')}
                        </div>
                    )}
                    {!activeDropdownLoading && !activeDropdownError && activeDropdownOptions.map((option) => (
                        <label
                            key={option}
                            style={{
                                display: 'flex',
                                alignItems: 'center',
                                padding: '8px',
                                cursor: 'pointer',
                                color: '#000',
                                fontSize: '14px',
                                whiteSpace: 'nowrap'
                            }}
                        >
                            <input
                                type="checkbox"
                                checked={selectedOrderBy === option || selectedDepartment === option || selectedJobType === option || selectedLocation === option}
                                onChange={() => {
                                    switch (selectedDropdown) {
                                        case Lang(lang, 'location'):
                                            if (selectedLocation === option) {
                                                setSelectedLocation('')
                                            } else {
                                                setSelectedLocation(option)
                                            }
                                            setSelectedDropdown('')
                                            break;
                                        case Lang(lang, 'department'):
                                            if (selectedDepartment === option) {
                                                setSelectedDepartment('')
                                            } else {
                                                setSelectedDepartment(option)
                                            }
                                            setSelectedDropdown('')
                                            break;
                                        case Lang(lang, 'jobType'):
                                            if (selectedJobType === option) {
                                                setSelectedJobType('')
                                            } else {
                                                setSelectedJobType(option)
                                            }
                                            setSelectedDropdown('')
                                            break;
                                        case Lang(lang, 'orderBy'):
                                            if (selectedOrderBy === option) {
                                                setSelectedOrderBy('')
                                            } else {
                                                setSelectedOrderBy(option)
                                            }
                                            setSelectedDropdown('')
                                            break;
                                        default:
                                            break;
                                    }
                                }}
                                style={{ marginRight: '8px' }}
                            />
                            {selectedDropdown === Lang(lang, 'orderBy') ? Lang(lang, option) : option}
                        </label>
                    ))}
                </div>}
            </div>
        </div>

        <div className="pt-4">
            {(selectedLocation || selectedDepartment || selectedJobType) &&
                <div className="flex flex-row justify-center gap-2 mb-6">
                    {selectedLocation && filterComponent(selectedLocation, () => setSelectedLocation(''))}
                    {selectedDepartment && filterComponent(selectedDepartment, () => setSelectedDepartment(''))}
                    {selectedJobType && filterComponent(selectedJobType, () => setSelectedJobType(''))}
                </div>
            }
            {filter ?
                <div className="flex flex-row justify-center gap-2">
                    {filterComponent(filter, () => {
                        setFilter(false);
                        setIDParam('');
                    })}
                </div> :
                jobListLoading ?
                    <p className='text-[#48494B] text-[18px] md:text-[22px] font-normal leading-tight text-center pt-6'>{Lang(lang, 'loading')}</p> :
                    jobListError ?
                        <div className="flex flex-col items-center gap-2 pt-6">
                            <p className='text-[#48494B] text-[18px] md:text-[22px] font-normal leading-tight text-center'>{Lang(lang, 'failed_to_load_jobs')}</p>
                            <button
                                type="button"
                                className="bg-[#034694] text-white rounded-full py-1 px-4 cursor-pointer font-semibold"
                                onClick={retryJobsAndFailedFilters}
                            >
                                {Lang(lang, 'retry')}
                            </button>
                        </div> :
                        <p className='text-[#48494B] text-[18px] md:text-[22px] font-normal leading-tight text-center pt-6'><b>{jobListTotal}</b> {Lang(lang, 'jobs_are_available')} </p>}
            <div className="w-[85%] md:w-[68%] mx-auto pt-4 flex flex-col justify-center items-center">
                <Accordion items={jobListData} isWithID={true} openIndex={filter} setIsDrawerOpen={setIsDrawerOpen} setDrawerTitle={setDrawerTitle} setJob={setJob} is_loading={isLoading} />
            </div>
            <div className="flex justify-center">
                {jobListData && (jobListTotal > (jobListData.length) && <a href="" className="bg-[#EA2427] text-white rounded-full py-1 px-4 cursor-pointer font-semibold" onClick={(e) => {
                    e.preventDefault();
                    loadJobata()
                }}>{Lang(lang, 'read_more')}</a>)}
            </div>
        </div>

        <JobDrawer
            isOpen={isDrawerOpen}
            setIsDrawerOpen={setIsDrawerOpen}
            title={drawerTitle}
            job={jobData}
        />

        {renderModal()}
    </div>)
}

export default Portal;
